import styled from "styled-components";

const ContainerBox = styled.div`
  width: 100%;
  @media only screen and (min-width: 768px) {
    max-width: calc(50% - 2rem);
  }
`;

export default ContainerBox;
